<i18n src="../../locales/lang.json"></i18n>

<template>
  <div class="container-fluid p-3">
    <div class="row mt-0">
      <div class="col px-0 custom-form-main-label">
        {{ msg }}
      </div>
    </div>
    <div class="row mt-3">
      <div class="col">
        <div class="row" v-for="shift in data">
          <input-checkbox @input="setOverride" v-bind:value="shift.SiteShiftId" v-bind:id="'chk_' +  shift.SiteShiftId"
                          v-bind:name="'chk_' +  shift.SiteShiftId" v-bind:checked="shift.IsAdded"
                          v-bind:text="shift.Name" class="mt-1"></input-checkbox>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import InputCheckbox from "../form-components/input-checkbox.vue";
  var msg = "";
  export default {
    name: "manage-location-shifts",
    components: {
      InputCheckbox,
    },
    props: {

    },
    data() {
      return {
        data: null,
        locationId: -1,
        dayId: -1,
        msg,
      };
    },
    methods: {
      setOverride(checked, val, value) {        
        this.createLocationShift(val, checked)
      },
      getId() {
        return this._uid;
      },
      async loadLocationShifts(locId, day, dayname, locationname) {
        try {
          this.msg = this.$store.translate('add_or_remove_shifts');
          this.msg = this.msg.replace('{0}', locationname).replace('{1}', dayname);
          this.locationId = locId;
          this.dayId = day;
          var url = `/api/Admin/v1/Shifts/Location/Day/${locId}/${day}`;
          this.$http.get(url).then(async response => {
            this.data = response.data;
            this.$forceUpdate();
          });
        }
        catch (err) {
          //alert('some error:' + err)
        }
      },
      async createLocationShift(shiftId, isChecked) {

        var request = {
          LocationId: this.locationId, SiteShiftId: shiftId, DayId: this.dayId, IsChecked: isChecked
        };

        try {
          var response = await this.$http.post(
            '/api/Admin/v1/Location/Shift',
            request
          ).then(async response => {

            if (this.data != null && this.data != undefined && this.data.length > 0) {
              var item = this.data.find(n => n.SiteShiftId == shiftId);
              console.log(item);
              if (item != null) {
                item.IsAdded = isChecked;
                console.log(item);
              }
            }

            var obj = { tab: "LocationShiftAdmin", action: "refreshlocshift", isclose: false };
            var data = JSON.stringify(obj);
            vm.$root.$emit('refreshview', data);
          });

        } catch (err) {
          alert(err);
        }
      },
    },
    watch: {
    },
    mounted() {

    }
  };
</script>

<style scoped>
  .select_container {
    width: calc(100%)
  }
</style>




// WEBPACK FOOTER //
// src/components/shift/manage-location-shifts.vue